import { render } from "./checkout.vue?vue&type=template&id=671f755f&scoped=true"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"

import "./checkout.vue?vue&type=style&index=0&id=671f755f&lang=scss&scoped=true"
import "./checkout.vue?vue&type=style&index=1&id=671f755f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671f755f"]])

export default __exports__